import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useContext } from 'react';

import { VisibilityPrivateIcon } from './assets/VisibilityPrivateIcon';
import { VisibilityPublicIcon } from './assets/VisibilityPublicIcon';
import { VisibilityRestrictedIcon } from './assets/VisibilityRestrictedIcon';
import { ApplicationContext } from '../../../../shared/source/context/context';

import type { VisibilityStatus } from './get-visibility-status';
import type { FunctionComponent } from 'react';

type VisibilityIndicatorIconProps = {
    readonly onClick?: () => void;
    readonly visibilityStatus: VisibilityStatus;
};

export const VisibilityIndicatorIcon: FunctionComponent<VisibilityIndicatorIconProps> = ({
    onClick,
    visibilityStatus,
}) => {
    const { translate } = useContext(ApplicationContext);

    if (visibilityStatus === 'private') {
        return (
            <Tooltip title={translate('pages.user-profile.profile-visibility.tooltips.private')}>
                <Button color="secondary" variant="text" onClick={onClick}>
                    <VisibilityPrivateIcon aria-label="visibility setting" />
                </Button>
            </Tooltip>
        );
    }
    if (visibilityStatus === 'restricted') {
        return (
            <Tooltip title={translate('pages.user-profile.profile-visibility.tooltips.restricted')}>
                <Button color="secondary" variant="text" onClick={onClick}>
                    <VisibilityRestrictedIcon aria-label="visibility setting" />
                </Button>
            </Tooltip>
        );
    }
    if (visibilityStatus === 'public') {
        return (
            <Tooltip title={translate('pages.user-profile.profile-visibility.tooltips.public')}>
                <Button color="secondary" variant="text" onClick={onClick}>
                    <VisibilityPublicIcon aria-label="visibility setting" />
                </Button>
            </Tooltip>
        );
    }

    return null;
};
